export const TAB_TYPE = {
  trend: {
    id: "trend",
    label: "Trend",
    index: 0,
  },
  comparision: {
    id: "comparision",
    label: "Comparison",
    index: 1,
  },
  revision: {
    id: "revision",
    label: "Revisions",
    index: 5,
  },
  surprise: {
    id: "surprise",
    label: "Surprise",
    index: 6,
  },
  valuation: {
    id: "valuation",
    label: "Valuation",
    index: 2,
  },
  charts: {
    id: "charts",
    label: "Charts",
    index: 4,
  },
  tpr: {
    id: "tpr",
    label: "Target Price & Ratings",
    index: 3,
  },
};

export const DEFAULT_CHART_TYPE = "trend";

export const CHART_TYPE_DATA = {
  trend: {
    id: DEFAULT_CHART_TYPE,
    label: "Trend",
    meta_id: "Charts_Trend",
  },
  comparison: {
    id: "comparison",
    label: "Comparison",
    meta_id: "Charts_Bar",
  },
  revision: {
    id: "revision",
    label: "Revision",
    meta_id: "Charts_Revision",
  },
};

export const CHART_TYPE_LIST = [
  { key: CHART_TYPE_DATA.trend.label, value: CHART_TYPE_DATA.trend.id },
  {
    key: CHART_TYPE_DATA.comparison.label,
    value: CHART_TYPE_DATA.comparison.id,
    disabled: false,
  },
  {
    key: CHART_TYPE_DATA.revision.label,
    value: CHART_TYPE_DATA.revision.id,
    disabled: false,
  },
];

export const TAB_BE_MAPPING = {
  trend: "Trend",
  comparison: "Comparison",
  valuation: "Valuation",
  tpr: "TPR",
  chart: "Chart",
  revision: "Revision",
  surprise: "Surprise",
};

export const DUPLICATE_NAME_ERROR_MSG =
  "Name already exists. Please enter a different one.";

export const EXIT_WITHOUT_SAVE_MSG =
  "You are about to leave the page without saving to your Custom Analysis. Save to Custom Analysis or Exit without saving.";

export const ACTION_BTN_DETAILS = {
  save: {
    header: "Save as new Custom Analysis",
    content_header: "Rename",
  },
  rename: {
    header: "Rename Custom Analysis",
    content_header: "Rename",
  },
  delete: {
    header: "Delete Custom Analysis",
    content_header: "",
  },
  duplicate: {
    header: "Save as new Custom Analysis",
    contenr_header: "Rename",
  },
  exit_without_saving: {
    header: "Save Custom Analysis",
    content_header: "Rename",
  },
};

export const TREND_REVISION_CHART_LEGEND_COLORS = [
  "#304da5",
  "#0f4040",
  "#a53088",
  "#d1d100",
  "#412504",
  "#6c30a5",
  "#073c5f",
  "#034c1a",
  "#871000",
  "#e88e82",

  "#9cade2",
  "#36abad",
  "#d275bb",
  "#e1e143",
  "#a87230",
  "#a575d2",
  "#1874ae",
  "#15813e",
  "#a61b08",
  "#f3bfb7",

  "#e6ebfc",
  "#82e5e6",
  "#f6d6ee",
  "#f4f4b1",
  "#eed7bb",
  "#e7d6f6",
  "#8bc3e3",
  "#66cd8f",
  "#c23824",
  "#fae1de",
];

export const COMPARISON_CHART_LEGEND_COLORS = ["#304da5", "#a53088", "#412504"];

export const USER_SETTINGS_LINE_ID = {
  Revision: "revision_line_ids",
  Surprise: "surprise_line_ids",
};
